import _Typography from "@mui/material/Typography";
import _CircularProgress from "@mui/material/CircularProgress";
import React from 'react';
import { styled } from 'styled-components';
export function Loading({
  text,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(_CircularProgress, {
    color: "primary"
  }), /*#__PURE__*/React.createElement(_Typography, null, text));
}
const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 32px);
  justify-content: center;
  padding: 16px;

  p {
    margin-top: 16px;
  }
`;